import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/_shared/shared.module';
import { ServicejobSearchResultDetailSJobComponent } from './servicejob-search-result-detail-sjob.component';
import { ObjectDetailComponentModule } from '../object-detail/object-detail.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    ObjectDetailComponentModule,
  ],
  declarations: [ServicejobSearchResultDetailSJobComponent],
  exports: [ServicejobSearchResultDetailSJobComponent],
})
export class ServicejobSearchResultDetailSJobModule {}
